import styled from 'react-emotion'
import { css } from 'emotion'

import { mq } from '../theme'

const ColumnList = styled('ul')`
	${mq.medium(css`
		column-count: 2;
		column-gap: 30px;
		column-span: 0;
		margin: 0 auto;
		margin-top: 3rem;
		orphans: 1;
		widows: 1;
		&>li {
			margin-left: 1rem;
			break-inside: avoid-column;
		}
	`)}
`

export default ColumnList